import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {retry} from 'rxjs/operators';
import {FusionAuthService} from '../../../shared/services/fusion-auth';
import {UrlProviderService} from '../../../shared/services/general';

@Injectable()
export class ReportsService {

  constructor(private urlProviderService: UrlProviderService, private httpClient: HttpClient, private fusionAuthService: FusionAuthService) {
  }

  public generateRequest(url: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders(),
      responseType: 'blob' as 'json',
    };
    httpOptions.headers.append('Authorization', this.fusionAuthService.getToken());
    httpOptions.headers.append('X-Authorization', this.fusionAuthService.getToken());

    return this.httpClient.get<any>(`${this.urlProviderService.ApiUrl}${url}`, httpOptions).pipe(retry(2));
  }

  public generateRequisitionReport(requisitionIds: number[] = []): Observable<any> {
    let url = `/v2/reports/requisition?`;
    const requisitionIdsArray: string[] = [];
    requisitionIds.map(x => {
      requisitionIdsArray.push(`requisitionIds=${x}`);
    });

    if (requisitionIdsArray.length > 0) {
      url += requisitionIdsArray.join('&');
    }

    return this.generateRequest(url);
  }

  public generateRequisitionLog(requisitionIds: number[] = []): Observable<any> {
    let url = `/v2/reports/requisition/log?`;
    const requisitionIdsArray: string[] = [];
    requisitionIds.map(x => {
      requisitionIdsArray.push(`requisitionIds=${x}`);
    });

    if (requisitionIdsArray.length > 0) {
      url += requisitionIdsArray.join('&');
    }

    return this.generateRequest(url);
  }

  public generateOrderPreview(results: any[] = []): Observable<any> {
    let url = `/v2/reports/order/results-preview`;

    const httpOptions = {
      headers: new HttpHeaders(),
      responseType: 'blob' as 'json',
    };
    httpOptions.headers.append('Authorization', this.fusionAuthService.getToken());
    httpOptions.headers.append('X-Authorization', this.fusionAuthService.getToken());

    return this.httpClient.post<any>(`${this.urlProviderService.ApiUrl}${url}`, results, httpOptions).pipe(retry(2));
  }

  public generateOrderResults(orderIds: number[] = []): Observable<any> {
    let url = `/v2/reports/order/results?`;
    const orderIdsArray: string[] = [];
    orderIds.map(x => {
      orderIdsArray.push(`orderIds=${x}`);
    });

    if (orderIdsArray.length > 0) {
      url += orderIdsArray.join('&');
    }

    return this.generateRequest(url);
  }

  public generateOrderLog(orderIds: number[] = []): Observable<any> {
    let url = `/v2/reports/order/log?`;
    const orderIdsArray: string[] = [];
    orderIds.map(x => {
      orderIdsArray.push(`orderIds=${x}`);
    });

    if (orderIdsArray.length > 0) {
      url += orderIdsArray.join('&');
    }

    return this.generateRequest(url);
  }

  public generateOrderDetails(orderIds: number[] = []): Observable<any> {
    let url = `/v2/reports/order/details?`;
    const orderIdsArray: string[] = [];
    orderIds.map(x => {
      orderIdsArray.push(`orderIds=${x}`);
    });

    if (orderIdsArray.length > 0) {
      url += orderIdsArray.join('&');
    }

    return this.generateRequest(url);
  }

  public generateCumulativeResults(queryString: string): Observable<any> {
    return this.generateRequest(`/v2/reports/order/cumulative-results?${queryString}`);
  }
}
